import { render } from "./ObjectGrid.vue?vue&type=template&id=5068f5de&scoped=true"
import script from "./ObjectGrid.vue?vue&type=script&lang=js"
export * from "./ObjectGrid.vue?vue&type=script&lang=js"

import "./ObjectGrid.vue?vue&type=style&index=0&id=5068f5de&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5068f5de"]])

export default __exports__